import { render, staticRenderFns } from "./pro_desc.vue?vue&type=template&id=c9f9a8dc&scoped=true"
import script from "./pro_desc.vue?vue&type=script&lang=js"
export * from "./pro_desc.vue?vue&type=script&lang=js"
import style0 from "./pro_desc.vue?vue&type=style&index=0&id=c9f9a8dc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9f9a8dc",
  null
  
)

export default component.exports